import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'typetoicon',
    standalone: false
})
export class TypeToIconPipe implements PipeTransform {
  transform(value: any): any {
    switch (value) {
      case 0:
        return 'mail'
      case 1:
        return 'call'
      case 2:
        return 'person'
      case 3:
        return 'history_edu'
      case 4:
        return 'fax'
      case 5:
        return 'flight_takeoff'
      default:
        return 'close'
    }
  }
}
